import lockersTile from 'assets/images/logo/Lockers_Logo.png';
import * as React from 'react';

/**
 * The Lockers product tile — the square mark in the ProductSwitcher dropdown and on the
 * DashboardChooser.
 *
 * ⚠️ RASTER, not a path set. Every other product tile in this folder is inline SVG; Lockers is the
 * one shipped as a PNG (`assets/images/logo/Lockers_Logo.png`, 512×512 with alpha) because that is
 * the form the new brand mark was delivered in. The consequences, so nobody is surprised:
 *
 *   - The ink tile, its corner radius and the mint gradient are BAKED IN. They cannot be retinted
 *     from a token the way LogoAccessIcon's `url(#gradient)` fills can. A palette change means a
 *     new export, not an edit here.
 *   - 512px covers every call site: the largest is DashboardChooser at 72 CSS px, which is 216px
 *     even at 3x DPR.
 *
 * `renderModuleIcon` (ProductSwitcher) clones this element with the union of props that every logo
 * type needs — `focusable` and `size` among them, which are SVG/ZezamiiIcon concerns. They are
 * destructured off below rather than spread, because React would otherwise emit them as invalid
 * attributes on an <img>. `size` is still HONOURED as the fallback dimension, since that is the
 * prop ZezamiiIcon-style callers pass instead of width/height.
 */
const LogoLockerApp = ({ width, height, size, style, focusable, inverted, color, ...props }) => {
	const w = width ?? size ?? 40;
	const h = height ?? size ?? w;

	return (
		<img
			src={lockersTile}
			alt=''
			width={w}
			height={h}
			{...props}
			// `block` kills the inline-image baseline gap, which would otherwise push the tile a
			// few px off-centre inside the switcher's flex row.
			style={{ display: 'block', ...style }}
		/>
	);
};

export default LogoLockerApp;
